// Vendor Libs
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

// Components
import Button from './button';

// Styles
import './form-updated.scss';

export default class FormUpdated extends Component {
    componentWillUnmount() {
        this.props.formSubmitReset();
    }

    getClass() {
        return classnames(
            {
                'form-updated': true,
                'form-updated_absolute': this.props.absolutePositioned,
            },
            this.props.className
        );
    }

    render() {
        return (
            <div className={this.getClass()}>
                <div>Dynamic Shelf successfully updated</div>
                <Button onClick={this.props.formSubmitReset}>Ok</Button>
            </div>
        );
    }
}

FormUpdated.propTypes = {
    absolutePositioned: PropTypes.bool,
    className: PropTypes.string,
    formSubmitReset: PropTypes.func.isRequired,
};
